module.exports = __webpack_public_path__ + "img/photo_in-use@2x.0935653b.jpg";